export default "__VITE_ASSET__d10d2e29__"